import { Application } from "@hotwired/stimulus"

// Create but don't start - let the main entrypoint handle that
// Debug logging is enabled by the entrypoint in development only
const application = new Application()

export { application }